import React from 'react';
import { AudioDevicesSelection, mapStateToProps, } from 'jitsi/device-selection/components/AudioDevicesSelection.web';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import { translate } from 'jitsi/base/i18n/functions';
import AudioInputPreview from 'jitsi/device-selection/components/AudioInputPreview.web';
import AudioOutputPreview from './AudioOutputPreview';
import Checkbox from 'jitsi/base/ui/components/web/Checkbox';
import DeviceHidContainer from 'jitsi/device-selection/components/DeviceHidContainer.web';
const styles = (theme) => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            padding: '0 2px',
            width: '100%',
        },
        inputContainer: {
            marginBottom: theme.spacing(3),
        },
        outputContainer: {
            margin: `${theme.spacing(5)} 0`,
            display: 'flex',
            alignItems: 'flex-end',
        },
        outputButton: {
            paddingBlock: '10px',
            marginLeft: theme.spacing(3),
        },
        noiseSuppressionContainer: {
            marginBottom: theme.spacing(5),
        },
    };
};
/**
 * React {@code Component} for previewing audio and video input/output devices.
 *
 * @augments Component
 */
class IISightAudioDevicesSelection extends AudioDevicesSelection {
    render() {
        const { classes, hasAudioPermission, hideAudioInputPreview, hideAudioOutputPreview, hideDeviceHIDContainer, hideNoiseSuppression, iAmVisitor, noiseSuppressionEnabled, selectedAudioOutputId, t, } = this.props;
        const { audioInput, audioOutput } = this._getSelectors();
        return (React.createElement("div", { className: classes.container },
            !iAmVisitor && (React.createElement("div", { "aria-live": 'polite', className: classes.inputContainer }, this._renderSelector(audioInput))),
            !hideAudioInputPreview && hasAudioPermission && !iAmVisitor && (React.createElement(AudioInputPreview, { track: this.state.previewAudioTrack })),
            React.createElement("div", { "aria-live": 'polite', className: classes.outputContainer },
                this._renderSelector(audioOutput),
                !hideAudioOutputPreview && hasAudioPermission && (React.createElement(AudioOutputPreview, { className: classes.outputButton, deviceId: selectedAudioOutputId }))),
            !hideNoiseSuppression && !iAmVisitor && (React.createElement("div", { className: classes.noiseSuppressionContainer },
                React.createElement(Checkbox, { checked: noiseSuppressionEnabled, label: t('toolbar.enableNoiseSuppression'), 
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange: () => super._onChange({
                        noiseSuppressionEnabled: !noiseSuppressionEnabled,
                    }) }))),
            !hideDeviceHIDContainer && !iAmVisitor && React.createElement(DeviceHidContainer, null)));
    }
}
export default connect(mapStateToProps)(withStyles(styles)(translate(IISightAudioDevicesSelection)));
